module.exports = __webpack_public_path__ + "img/tema-1-8.e31e2435.png";